import classnames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import MaskedInput from 'react-text-mask';
import { useFormContainerContext } from '../../../../context/formContainerContext';
import { getObjectValueByStringPath } from '../../../../utils/system';
import { getFormVariable } from '../../utils';
import type { IFormTypeProps } from '../../../../types';
import type { Mask } from 'react-text-mask';

export const MaskText = ({ params, className = '', type = 'text', registerOptions, icon, handleClickIcon }: IFormTypeProps) => {
  const { name, disabled, label, validate, ...args } = params;
  const { maxLength, required, placeholder, pattern } = getFormVariable(args);
  const {
    formState: { errors },
    control,
  } = useFormContext();
  const { isFormLoading, isFormSubmitted } = useFormContainerContext();

  const isDisabled = !!disabled || isFormLoading || isFormSubmitted;

  const objectValue = getObjectValueByStringPath(errors, name);

  return (
    <>
      <div
        className={classnames('wrapper-input', className, {
          disabled: isDisabled,
        })}
      >
        <div className='input-container'>
          <Controller
            name={name}
            control={control}
            defaultValue=''
            rules={{
              required,
              maxLength,
              pattern,
              validate,
            }}
            render={({ field }) => (
              <MaskedInput
                type={type}
                mask={args.mask as Mask}
                id={name}
                className={classnames({ error: errors && objectValue })}
                value={field.value}
                onChange={registerOptions?.onChange || field.onChange}
                disabled={isDisabled}
                placeholder={placeholder}
                autoComplete='off'
                required={args.required}
              />
            )}
          />
          {icon && (
            <div className='icon' onClick={handleClickIcon}>
              {icon}
            </div>
          )}
        </div>
        {!!label && (
          <label htmlFor={name}>
            {label}
            {args.required && <sup>*</sup>}
          </label>
        )}
        {errors && objectValue && <span className='error'>{objectValue?.message}</span>}
      </div>
    </>
  );
};
